import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonComponent from '../button/button_component';
import ico_audifonos from '../../assets/icons/ico_audifonos.svg';
import cn from './../../lib/bem';


import './modal_component.scss';

const ModalComponent = ({msgError}) => {
    
    const classes = cn("modalComponent");
    const history = useNavigate();

    const variableName = `REACT_APP_MSG_RESCATE_ERROR_${msgError}`;
    const mensajeError = process.env[variableName];

    return (
       
            <div className={classes()}>
                <div className={classes('modal-content')}>
                    <div className={classes('modal-header')}>
                        <img src={ico_audifonos} alt={'ico_audifonos'} />
                    </div>
                    <div className={classes('modal-body')}>
                        <p className={classes('modal-title')} ><b>Estamos listo para asistirte</b></p>
                        <p className={classes('modal-desc')} dangerouslySetInnerHTML={{ __html: mensajeError}}></p>
                    </div>
                    <div className={classes('modal-footer')}>
                        <ButtonComponent 
                            label={'btnAceptar'}
                            tipo={'button-red'}
                            nombre={'Aceptar'}
                            disabled={false}
                            action={() => history('/')}
                        />
                    </div>
                </div>
            </div>
    )

}

export default ModalComponent;